const fontWeights = {
  extraLight: 100,
  light: 200,
  normal: 400,
  bold: 600,
  display: 700,
};

export default fontWeights;
